// @owners { team: patients-team }
import { useQuery } from '@tanstack/react-query';
import { usePrescriptionsInCart } from '~shared/features/cart/hooks/usePrescriptionsInCart';
import { staleTimes } from '~shared/queries/constants';
import { queries } from '~shared/queries/query-keys';

export const useEnterCheckoutFlow = ({ enabled }: { enabled?: boolean } = {}) => {
  const { prescriptionIDs: cartPrescriptionIDs } = usePrescriptionsInCart();
  const { data, isError, isLoading, refetch } = useQuery({
    ...queries.enterCheckout.enterCheckout({
      cart_prescription_ids: cartPrescriptionIDs,
    }),
    staleTime: staleTimes.fiveMinutes,
    enabled,
  });

  return {
    isError,
    isLoading,
    refetch,
    earliestDateCompoundData: data?.earliestDateCompoundData,
    photoIDUploadData: data?.photoIDUploadData,
    flowData: data?.flowData,
    flowTypes: data?.flowTypes,
    error: data?.error,
  };
};
